import { getHistoryDevice, getHistoryDeviceIS } from "../../Reducers/historyDevice/getHistoryDeviceReducer";
import { getHistoryToExcel } from "../../../business/Reducers/historyDevice/getHistoryDeviceToExcelReducer";
import { useReducer } from "react"
import { globalInitialState } from "../initialStateGlobal";

export const useHistoryDeviceState = () =>{
  const [state, dispatch] = useReducer(getHistoryDevice, getHistoryDeviceIS);
  return {state, dispatch};
}

export const useGetHistoryDeviceToExcelState = () => {
  const [state, dispatch] = useReducer(getHistoryToExcel, globalInitialState);
  return { state, dispatch };
}
